module.exports = __webpack_public_path__ + "static/img/nick-morrison-325805-unsplash.d9cee1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/nick-morrison-325805-unsplash.jpg
// module id = qDrq
// module chunks = 1